import { ManagedAxleDialogBase } from '@/dialogs/ManagedAxleDialog';
import { AxleV2Theme } from '@/theme';
import { ThemeProvider, styled } from '@mui/material';
import { FC, ReactElement } from 'react';

// Fixed dialog dimensions so switching tabs doesn't resize the modal.
// Cap at 1000px on tall viewports; the calc preserves MUI Dialog's default
// 32px top/bottom margins.
const StyledDialogBase = styled(ManagedAxleDialogBase)`
    & .MuiPaper-root {
        box-sizing: border-box;
        height: 100%;
        max-height: min(1000px, calc(100% - 64px));
        max-width: 1000px;
        width: 100%;
        display: flex;
        flex-direction: column;
        overflow: hidden;
    }
`;

type DecisionSupportDialogShellProps = {
    title: string;
    onClose(): void;
    children: (args: { onClose(): void }) => ReactElement | null;
};

// Themed, fixed-size modal shell shared by the visitAssignment clinician/date
// recommendation dialogs.
export const DecisionSupportDialogShell: FC<DecisionSupportDialogShellProps> = ({
    title,
    onClose,
    children,
}) => (
    <ThemeProvider theme={AxleV2Theme}>
        <StyledDialogBase title={title} onClose={onClose}>
            {children}
        </StyledDialogBase>
    </ThemeProvider>
);
